// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nyxwR","container":"Layout_container__t732+","main":"Layout_main__FxQfo","mainShifted":"Layout_mainShifted__faFd8"};